import type React from 'react'
import { Outlet } from 'react-router-dom'
import { useHasPermission } from '@/domains/shared/hooks/useHasPermission'
import type { Action } from '@/domains/shared/permissions/actions'
import ForbiddenPage from '@/domains/shared/routes/ForbiddenPage'

interface Props {
  /** The catalogue action(s) every route below needs; a list means all of them. */
  action: Action | readonly Action[]
}

/**
 * Route guard: renders the nested routes when the signed-in user holds `action`,
 * the Forbidden page otherwise. Sits under `AuthenticatedLayout`, so the sidebar
 * stays and the user can move on. Use it as a pathless layout route:
 *
 *   <Route element={<RequirePermission action="products.view" />}>
 *     <Route path="/products" element={...} />
 *   </Route>
 */
export const RequirePermission: React.FC<Props> = ({ action }) => {
  const allowed = useHasPermission(action)
  return allowed ? <Outlet /> : <ForbiddenPage />
}
